import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "outuput-product" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Récapitulatif des produits choisis", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("td", null, "Quantité"),
  /*#__PURE__*/_createElementVNode("td", null, "Nom"),
  /*#__PURE__*/_createElementVNode("td", null, "Couleur"),
  /*#__PURE__*/_createElementVNode("td", null, "Tarif"),
  /*#__PURE__*/_createElementVNode("td", null, "Total")
], -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "cell-right" }
const _hoisted_6 = { class: "cell-right bold" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" unité")
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "cell-right" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "cell-right bold" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { class: "total" }
const _hoisted_22 = { class: "api-result" }
const _hoisted_23 = { class: "buttons" }
const _hoisted_24 = { key: 1 }

import { apiHandler } from '@/api/ApiHandler'
import {
  ChoosenAccessoire,
  IProduct,
  ID_ROULEAU,
  ID_U_DEPART_1,
  ID_U_DEPART_2,
} from '@/model/Product'
import { computed, PropType, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  products: { type: Array as PropType<ChoosenAccessoire[]>, default: () => [] },
  lame: {
    type: Object as PropType<ChoosenAccessoire | undefined>,
    default: () => undefined,
  },
  surface: { type: Number as PropType<number>, default: () => 0 },
  ml: { type: Number as PropType<number>, default: () => 0 },
},
  setup(__props) {

const props = __props



const loadingAddToCart = ref(false)

const message = ref('')
const success = ref(false)

const getTarifLame = (quantity: number, product: IProduct): string => {
  // const surfacePerLame = (+product.surface * +product.longueur)
  // const ml = (+product.longueur * quantity)

  if (props.surface <= 70) {
    return '' + (+product.tarif_10_ml || 0).toFixed(2)
  } else if (props.surface <= 120) {
    return '' + (+product.tarif_50_ml || 0).toFixed(2)
  } else if (props.surface <= 200) {
    return '' + (+product.tarif_100_ml || 0).toFixed(2)
  } else {
    return '' + (+product.tarif_200_ml || 0).toFixed(2)
  }
}

const getTarif = (quantity: number, product: IProduct): number => {
  if (props.surface <= 70) {
    return +product.tarif_10_ml || 0
  } else if (props.surface <= 120) {
    return +product.tarif_50_ml || 0
  } else if (props.surface <= 200) {
    return +product.tarif_100_ml || 0
  } else {
    return +product.tarif_200_ml || 0
  }
}

const computeTarifLame = (quantity: number, product: IProduct): string => {
  const ratio = +product.surface * +product.longueur
  if (props.surface <= 70) {
    return (Math.ceil(quantity) * +product.tarif_10_ml * ratio).toFixed(2)
  } else if (props.surface <= 120) {
    return (Math.ceil(quantity) * +product.tarif_50_ml * ratio).toFixed(2)
  } else if (props.surface <= 200) {
    return (Math.ceil(quantity) * +product.tarif_100_ml * ratio).toFixed(2)
  } else {
    return (Math.ceil(quantity) * +product.tarif_200_ml * ratio).toFixed(2)
  }
}

const computeTarif = (quantity: number, product: IProduct): number => {
  if (props.surface <= 70) {
    return Math.ceil(quantity) * +product.tarif_10_ml
  } else if (props.surface <= 120) {
    return Math.ceil(quantity) * +product.tarif_50_ml
  } else if (props.surface <= 200) {
    return Math.ceil(quantity) * +product.tarif_100_ml
  } else {
    return Math.ceil(quantity) * +product.tarif_200_ml
  }
}

const computeTarifFormatted = (quantity: number, product: IProduct): string => {
  return `${computeTarif(quantity, product).toFixed(2)} €`
}

const computeTarifLameFormatted = (
  quantity: number,
  product: IProduct,
): string => {
  return `${computeTarifLame(quantity, product)} €`
}

const total = computed(() => {
  let total = 0
  for (const product of props.products) {
    if (
      product.product?.condition_type === 'ml' &&
      product.product?.idp !== ID_ROULEAU
    ) {
      total += computeTarif(product.quantity, product.product)
    } else {
      total += computeTarif(product.amount, product.product)
    }
  }

  if (props.lame) {
    total += +computeTarifLame(
      Math.ceil(props.lame.quantity / 2) * 2,
      props.lame.product,
    )
  }

  return total.toFixed(2)
})

const addToCart = async () => {
  loadingAddToCart.value = true

  const accessoires = props.products.map((p) => {
    return {
      idp: p.product?.idp,
      idd: p.product?.idd,
      quantity: p.amount,
    }
  })

  const lame = {
    idp: props.lame?.product.idp,
    idd: props.lame?.product.idd,
    quantity: props.ml,
  }

  const products = [...accessoires, lame]

  const response = await apiHandler.post('', { products: products })
  loadingAddToCart.value = false

  if (response.success) {
    message.value = `La commande est ajoutée au panier`
    success.value = true

    window.location.href =
      'https://www.bardagefacile.fr/bardage-facile-mon-panier'
  } else {
    message.value = `Impossible d'ajouter la commande au panier`
    success.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("table", null, [
      _hoisted_3,
      _createElementVNode("tbody", null, [
        (__props.lame)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
              _createElementVNode("td", null, _toDisplayString(`${Math.ceil(__props.lame.quantity / 2)} paquet${
                Math.ceil(__props.lame.quantity / 2) > 1 ? 's' : ''
              } de 2 lames`), 1),
              _createElementVNode("td", null, _toDisplayString(__props.lame?.product?.titre_base), 1),
              _createElementVNode("td", null, _toDisplayString(__props.lame?.product.couleur), 1),
              _createElementVNode("td", _hoisted_5, _toDisplayString(getTarifLame(Math.ceil(__props.lame.quantity / 2) * 2, __props.lame?.product)) + " € / m² ", 1),
              _createElementVNode("td", _hoisted_6, [
                _createElementVNode("span", null, _toDisplayString(computeTarifLameFormatted(
                Math.ceil(__props.lame.quantity / 2) * 2,
                __props.lame?.product,
              )), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.products.filter((p) => p.quantity), (product) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: product.product?.idd
          }, [
            _createElementVNode("td", null, [
              _createTextVNode(_toDisplayString(`${product.quantity}`) + " ", 1),
              (
                product.product?.condition_type === 'ml' ||
                product.product?.idp === _unref(ID_ROULEAU) ||
                product.product?.idp === _unref(ID_U_DEPART_1) ||
                product.product?.idp === _unref(ID_U_DEPART_2)
              )
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, " (ml)"))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, [
                    _hoisted_9,
                    (product.quantity > 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, "s"))
                      : _createCommentVNode("", true)
                  ]))
            ]),
            _createElementVNode("td", null, _toDisplayString(product.product.titre_base), 1),
            _createElementVNode("td", null, _toDisplayString(product.product.couleur), 1),
            _createElementVNode("td", _hoisted_11, [
              (
                product.product?.condition_type === 'ml' &&
                product.product?.idp !== _unref(ID_ROULEAU)
              )
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(getTarif(product.quantity, product.product)) + " € / ml ", 1))
                : (
                product.product?.idp === _unref(ID_U_DEPART_1) ||
                product.product?.idp === _unref(ID_U_DEPART_2)
              )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString((getTarif(product.quantity, product.product) / 6).toFixed(2)) + " € / ml ", 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_14, [
                      (product.product.idp === _unref(ID_ROULEAU))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString((getTarif(product.amount, product.product) / 60).toFixed(2)) + " € / ml ", 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(getTarif(product.amount, product.product)) + " € / paquet ", 1))
                    ]))
            ]),
            _createElementVNode("td", _hoisted_17, [
              (
                product.product?.condition_type === 'ml' &&
                product.product?.idp !== _unref(ID_ROULEAU)
              )
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(computeTarifFormatted(product.quantity, product?.product)), 1))
                : (
                product.product?.idp === _unref(ID_U_DEPART_1) ||
                product.product?.idp === _unref(ID_U_DEPART_2)
              )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(computeTarifFormatted(product.quantity / 6, product?.product)), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(computeTarifFormatted(product.amount, product?.product)), 1))
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("p", _hoisted_21, "Total " + _toDisplayString(_unref(total)) + " €", 1),
    _createElementVNode("div", _hoisted_22, [
      (message.value)
        ? (_openBlock(), _createElementBlock("h3", {
            key: 0,
            class: _normalizeClass(["message", { error: !success.value }])
          }, _toDisplayString(message.value), 3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_23, [
      (!loadingAddToCart.value)
        ? (_openBlock(), _createElementBlock("dig-ui-standard-button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (addToCart()))
          }, " Ajouter au panier "))
        : _createCommentVNode("", true),
      (loadingAddToCart.value)
        ? (_openBlock(), _createElementBlock("dig-ui-loader", _hoisted_24))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})